import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React, { Dispatch, SetStateAction } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import {
  ITargetingPresetHeaderBidder,
  patchTargetingPresetHeaderBidder,
} from '~/src/dash/apiV2/targeting/targetingPresets';
import { FONT_WEIGHT } from '~/src/dash/components/text/common';

interface IProps {
  preset: Partial<ITargetingPresetHeaderBidder>;
  handleSuccess: (preset: ITargetingPresetHeaderBidder) => void;
  open: boolean;
  handleClose: () => void;
  setSnackbarError: Dispatch<SetStateAction<boolean>>;
  setSnackbarMessage: React.Dispatch<React.SetStateAction<string>>;
  publisherID: string;
}

export const UpdateTargetingPresetBidderDialog = ({
  open,
  preset,
  handleSuccess,
  handleClose,
  setSnackbarError,
  setSnackbarMessage,
  publisherID,
}: IProps) => {
  const handleUpdate = () => {
    patchTargetingPresetHeaderBidder(publisherID, preset)
      .then((res) => {
        if (res.Preset) {
          handleSuccess(res.Preset);
        } else {
          unstable_batchedUpdates(() => {
            setSnackbarMessage('An error has occurred.');
            setSnackbarError(true);
          });
          handleClose();
        }
      })
      .catch((err) => {
        console.error(err);
        unstable_batchedUpdates(() => {
          setSnackbarMessage('An error has occurred. Please check your values and try again.');
          setSnackbarError(true);
        });
        handleClose();
      });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-update-preset'
      aria-describedby='alert-dialog-update-preset'
    >
      <DialogTitle id='alert-dialog-title'>{`Update: ${preset.Name}?`}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          Updating a targeting preset{' '}
          <span style={{ fontWeight: FONT_WEIGHT.bold, fontStyle: 'italic' }}>affects</span> all
          associated bidders with the new parameters. To edit a bidder, go to their settings, toggle
          off the preset, and add desired parameters.
        </DialogContentText>
        <DialogContentText>{`Should ${preset.Name} be updated?`}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleUpdate} autoFocus>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};
